/**
 * Normalize a free-form list of email addresses into a canonical
 * comma-separated string. Accepts commas, semicolons, and whitespace
 * (including newlines) as separators, and drops empty entries.
 */
export function normalizeEmailList(input: string | null | undefined): string {
  return (input || '')
    .split(/[\s,;]+/)
    .filter(Boolean)
    .join(',');
}
